import { render, staticRenderFns } from "./blocMallFlow.vue?vue&type=template&id=6367ceba&scoped=true&"
import script from "./blocMallFlow.vue?vue&type=script&lang=js&"
export * from "./blocMallFlow.vue?vue&type=script&lang=js&"
import style0 from "./blocMallFlow.vue?vue&type=style&index=0&id=6367ceba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6367ceba",
  null
  
)

export default component.exports